import * as yup from "yup";

export const EditProfileSchema = yup.object({
  name: yup.string().required("Campo requerido"),
  lastName: yup.string().required("Campo requerido"),
  secondLastName: yup.string().required("Campo requerido"),
  email: yup
    .string()
    .email("El correo electrónico no es válido")
    .required("Campo requerido"),
  phone: yup
    .string()
    .required("Campo requerido")
    .matches(/^\d{10}$/, "Debe ser un número de 10 dígitos"),
  idSchooling: yup
    .number()
    .required("Campo requerido")
    .positive("Campo requerido")
    .integer("Campo requerido"),
  address: yup.string().required("Campo requerido"),
  birthdate: yup
    .date()
    .required("Campo requerido")
    .max(new Date(), "Fecha invalida"),
  genere: yup.string().required("Campo requerido"),
  maritalStatus: yup.string().required("Campo requerido"),
  rfc: yup
    .string()
    .required("Campo requerido")
    .matches(
      /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
      "Campo requerido"
    ),
  nss: yup.string().required("Campo requerido"),
  idMex: yup
    .string()
    .required("Campo requerido")
    .matches(/^\d{9}$/, "Debe ser un número de 9 dígitos"),
  ocr: yup.string().required("Campo requerido").matches(/^\d{9}$/, "Debe ser un número de 9 dígitos"),
  alergias: yup.string().required("Campo requerido"),
  tipoSangre: yup.string().required("Campo requerido"),
  enfermedad: yup.string().required("Campo requerido"),
  tratamiento: yup.string().required("Campo requerido"),
});
